import { useRoot } from '-app/root'

export function useOrderModel() {
  const { order } = useRoot()

  return order
}
